import { render, staticRenderFns } from "./RoomCategoryList.vue?vue&type=template&id=6855519c"
import script from "./RoomCategoryList.vue?vue&type=script&lang=js"
export * from "./RoomCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports